import script from "./notices.vue?vue&type=script&lang=ts&setup=true"
export * from "./notices.vue?vue&type=script&lang=ts&setup=true"

import "./notices.vue?vue&type=style&index=0&id=dcaaaed0&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcaaaed0"]])

export default __exports__